module.exports = __webpack_public_path__ + "img/logo.308f1def.jpg";